import {
  INTEGRATION_TYPES,
  type IntegrationDefinition,
  type IntegrationEndpointInfo,
} from '../types'

import { DEFAULT_REQUEST311_CONFIG, Request311EditableFields } from './Request311EditableFields'

const REQUEST311_ENDPOINTS: IntegrationEndpointInfo[] = [
  {
    name: 'Get Types',
    method: 'GET',
    description: 'List all available request type IDs with their names',
    toolName: 'get_types',
  },
  {
    name: 'Create Case',
    method: 'POST',
    description: 'Create a new Request311 case',
    toolName: 'create_case',
  },
  {
    name: 'Get Case',
    method: 'GET',
    description: 'Retrieve details of an existing Request311 case by ID',
    toolName: 'get_case',
  },
  {
    name: 'Get Prompt',
    method: 'GET',
    description: 'Gets the public prompt for a request type',
    toolName: 'get_prompt',
  },
  {
    name: 'Get Knowledge Articles',
    method: 'GET',
    description: 'Get knowledge articles related to 311 request types',
    toolName: 'get_knowledge_articles',
  },
]

export const request311Integration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.REQUEST311,
  title: 'Catalis Request311',
  defaultConnectionName: 'Catalis Request311',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/catalis-logo.png',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/catalis-icon.png',
  cardDescription:
    'Connect to Catalis Request311 to manage citizen service requests and track issues. The integration will automatically configure all requested endpoints.',
  modalDescription:
    'Connect to Catalis Request311 to manage citizen service requests. The integration will automatically configure all requested API endpoints.',
  formFields: [
    {
      name: 'host',
      label: 'Host',
      placeholder: 'e.g., columbusga.qscend.com',
      helperText: 'The Request311 API host for your organization (without https://)',
      required: true,
      type: 'text',
    },
    {
      name: 'apiKey',
      label: 'API Key',
      placeholder: 'Enter your Request311 API key',
      helperText: 'Your API key is stored securely and encrypted',
      required: true,
      type: 'password',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-request311-integration/',
    buildPayload: (formData, config, organizationId, organizationIdentityId) => {
      const typedConfig = config as {
        required_submitter_fields?: string[]
        excluded_endpoints?: string[]
      }
      return {
        organization_identity_id: organizationIdentityId,
        api_key: formData.apiKey,
        host: formData.host,
        connection_name: formData.connectionName || 'Catalis Request311',
        required_submitter_fields:
          typedConfig.required_submitter_fields ||
          DEFAULT_REQUEST311_CONFIG.required_submitter_fields,
        excluded_endpoints: typedConfig.excluded_endpoints || [],
      }
    },
    authTokenName: 'query_param',
  },
  defaultConfig: { ...DEFAULT_REQUEST311_CONFIG },
  endpoints: REQUEST311_ENDPOINTS,
  hostValidation: { pattern: /^[a-zA-Z0-9-]+\.qscend\.com$/, example: 'columbusga.qscend.com' },
  EditableFieldsComponent: Request311EditableFields,
}
